package one.healthium.promo_banner.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.platform.LocalUriHandler
import one.healthium.ui.compose.components.banner.BannerContainer
import one.healthium.ui.compose.components.banner.rememberBannerHostState
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun PromoBannerBloc(
    content: @Composable () -> Unit
) {
    val viewModel = koinViewModel<PromoBannerViewModel>()
    val state by viewModel.state.collectAsState()
    val uriHandler = LocalUriHandler.current

    val bannerHostState = rememberBannerHostState<PromoBannerData>()

    LaunchedEffect(Unit) {
        viewModel.showBanner()
    }

    LaunchedEffect(state.bannerData) {
        state.bannerData?.let { bannerData ->
            bannerHostState.showBanner(bannerData)
        }
    }

    BannerContainer(
        bannerHostState = bannerHostState,
        bannerContent = { data ->
            PromoBanner(
                onClick = { uriHandler.openUri(data.url) }
            )
        }
    ) {
        content()
    }
}
